export function getViewportDimensions() {
  const height = window.innerHeight || "";
  const width = window.innerWidth || "";
  return typeof width === "number" && typeof height === "number"
    ? `${width}:${height}`
    : "";
}
